'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$93() {
  this.bJl = null;
  this.bJm = false;
}
export { $c_Lpresto_TwoFactorAuthView$$anon$93 as $c_Lpresto_TwoFactorAuthView$$anon$93 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$93.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$93;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$93() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$93 as $h_Lpresto_TwoFactorAuthView$$anon$93 };
$h_Lpresto_TwoFactorAuthView$$anon$93.prototype = $p;
$p.P = (function() {
  if ((!this.bJm)) {
    this.bJl = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T8($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$()));
    this.bJm = true;
  }
  return this.bJl;
});
var $d_Lpresto_TwoFactorAuthView$$anon$93 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$93, "presto.TwoFactorAuthView$$anon$93", ({
  Tx: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$93 as $d_Lpresto_TwoFactorAuthView$$anon$93 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$93.js.map
